<template>
  <!-- 小组排名 -->
  <div class="group-pk-box">
    <div class="pk-top">
      <p class="title"><span>屏2：小组排名</span></p>
      <div class="pk-top-right">
        <el-date-picker :picker-options="pickerOptions" v-model="time_select" value-format="yyyy-MM-dd" type="date"
                        placeholder="选择日期" @change="timeChange()">
        </el-date-picker>
        <p class="small">*数据每十秒钟更新一次</p>
      </div>
    </div>
    <div class="main-box" v-show="tableData.length>0">
      <div class="topChart">
        <div>
          <ul v-if="stuAdvanceRankData.length>0">
            <li v-for="(item,index) in stuAdvanceRankData" :key="index" v-show="index<3">
              <div class="list">
                <h5>{{ item.xzmc }}</h5>
                <div>
                  <p>总词汇量</p>
                  <p>{{ item.yzwsl ? item.yzwsl : 0 }}</p>
                </div>
                <div>
                  <p>平均词汇量</p>
                  <p>{{ item.pjchl ? item.pjchl : 0 }}</p>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="bottomChart">
        <el-table stripe :data="tableData" height="calc(100% - 90px)">
          <el-table-column width="80" label="排名" :index="indexMethod" type="index">
          </el-table-column>
          <el-table-column property="xzmc" width="180" label="小组名">
          </el-table-column>
          <el-table-column property="cjrq" width="180" label="创建时间">
            <template slot-scope="scope">
              <span>{{ new Date(scope.row.cjrq).Format("yyyy-MM-dd") }}</span>
            </template>
          </el-table-column>
          <el-table-column property="yzwsl" label="总词汇量" width="100">
          </el-table-column>
          <el-table-column property="pjchl" label="平均词汇量" width="100">
          </el-table-column>
          <el-table-column property="xsidAndMcRespList" label="组员及个人词汇量">
            <template slot-scope="scope">
              <el-tag style="margin-right:10px" size="small" v-for="(list,index) in scope.row.xsidAndMcRespList"
                      :key="index">{{ list.xsxm + ' : ' }}{{ (list.yzwl ? list.yzwl : 0) + '个' }}
              </el-tag>
            </template>
          </el-table-column>
        </el-table>
        <div class="tea-pagination">
          <el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange"
                         :current-page="pages.currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pages.pageSize"
                         layout="total, sizes, prev, pager, next, jumper" :total="pages.total">
          </el-pagination>
        </div>
      </div>
      <el-switch
          v-model="keepAbsentStudents"
          style="margin-left: 20px;"
          active-text="保留缺勤"
          inactive-text="移除缺勤"
          @change="handleKeepAbsentChange">
      </el-switch>
      <div class="group-list">
        <div class="group-item" v-for="(item,index) in tableData" :key="index">
          <div class="group-box">
            <div class="group-name">{{ item.xzmc }}</div>
            <div class="group-progress">排名：第<span
                style="font-size:25px;margin:0 2px;color:#F56C6C">{{ index + 1 }}</span>名<span
                style="margin-left:10px">平均<span
                style="font-size:25px;margin:0 2px;color:#67C23A">{{ item.pjchl }}</span>个</span></div>
            <div class="group-student">
              <div class="group-student-item" v-for="(itm,inx) in item.xsidAndMcRespList" :key="inx">
                <span style="font-size: 19px;font-weight: 500 ">{{ itm.xsxm }}</span>
                <div class="group-student-speed">
                  <el-progress :stroke-width="12" :percentage="format(maxChl,itm.yzwl)*100"
                               :format="function(){return null}" :color="customColorMethod"></el-progress>
                </div>
                <div class="img-gif">
                  <img style="width:60px;height:60px;" :src="require('../../../assets/images/teacher/q1.gif')" alt=""
                       v-show="inx==0">
                  <img style="width:50px;height:50px;" :src="require('../../../assets/images/teacher/q2.gif')" alt=""
                       v-show="inx==1">
                  <img style="width:50px;height:50px;" :src="require('../../../assets/images/teacher/q3.gif')" alt=""
                       v-show="inx==2">
                  <img style="width:50px;height:50px;transform: scaleX(-1);"
                       :src="require('../../../assets/images/teacher/q6.gif')" alt=""
                       v-show="inx==3">
                  <img style="width:60px;height:60px;transform: scaleX(-1);"
                       :src="require('../../../assets/images/teacher/q7.gif')" alt=""
                       v-show="inx==4">
                  <img style="width:50px;height:50px;" :src="require('../../../assets/images/teacher/q4.gif')" alt=""
                       v-show="inx==5">
                  <img style="width:50px;height:50px;transform: scaleX(-1);"
                       :src="require('../../../assets/images/teacher/q8.gif')" alt="" v-show="inx>5">
                </div>
                <span style="font-size:19px;color:#666;margin-left: 18px">{{ itm.yzwl }}个</span>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="empty">
      <el-empty description="暂无数据" class="" v-show="tableData.length==0"></el-empty>
    </div>
  </div>
</template>
<script>
import {classTempGroupGradeScreenHaveSingle, screenGroupRankingApi} from '@/api/teacher.js'

export default {
  name: 'finishStat',
  // components: { Pagination },
  data() {
    return {
      maxChl: 0,
      keepAbsentStudents: true, // 默认保留缺勤学生
      search_data: {
        yhid: this.$store.state.userInfo.yhid,
        zhid: this.$store.state.userInfo.zhid,
        bjid: this.$route.query.bjid,
        bjmc: this.$route.query.bjmc,
        jxid: this.$route.query.jxid,
      },
      pages: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      stuAdvanceRankData: [],
      tableData: [1],
      pickerOptions: {
        disabledDate: (time) => {
          return this.dealDisabledDate(time)
        }
      },
      time_select: null,//当前时间
      time_section: [],//可选择时间区间
    }
  },
  created() {
    const time_options = JSON.parse(this.$route.query.time)
    this.time_section = [time_options.yxqq, time_options.yxqz];
    this.time_select = time_options.now_select;
  },
  mounted() {
    this.getGroupRankingList()
    this.getClassTempScreenList()
    this.setTimer()

  },
  beforeDestroy() {
    clearInterval(this.timer)
  },

  methods: {
    // 切换处理方法
    handleKeepAbsentChange() {
      console.log(this.keepAbsentStudents)
      // 切换时重新获取数据
      this.getClassTempScreenList();
    },
    getClassTempScreenList() {
      const data = this.search_data;
      data.currentPage = Number(data.currentPage)
      data.pageSize = Number(data.pageSize)
      console.log(data)

      if (this.keepAbsentStudents) {
        // 保留缺勤学生
        this.getGroupRankingList()
      } else {
        // 移除缺勤学生
        this.getGroupRankingListAbsence(data)
      }
    },
    format(average, num) {
      const percentage = (Number(num) / Number(average)).toFixed(2)
      console.log(percentage)
      return percentage
    },
    customColorMethod(percentage) {
      if (percentage < 50) {
        return '#E86452';
      } else if (percentage < 60) {
        return '#E6A23C';
      } else if (percentage < 70) {
        return '#5B8FF9';
      } else if (percentage < 80) {
        return '#6f7ad3';
      } else if (percentage < 90) {
        return '#5AD8A6';
      } else if (percentage > 90) {
        return '#67C23A';
      }
    },
    // 日期禁选
    dealDisabledDate(time) {
      let start = new Date(this.$utils.getNowTime(0, 0, -1, this.time_section[0])).getTime();
      let now = new Date(this.$utils.getNowTime(0, 0, 0,)).getTime()
      let end = new Date(this.time_section[1]).getTime();
      if (end > now) {
        end = now
      }
      return time < start || time > end
    },
    timeChange() {
      this.handelSearch()
    },
    // 获取小组排名
    getGroupRankingList() {
      const data = this.search_data;
      data.currentPage = this.pages.currentPage;
      data.pageSize = this.pages.pageSize;
      data.qryDate = this.time_select;
      data.bjrs = 4;
      screenGroupRankingApi(data).then(res => {
        if (res.result) {
          this.pages.total = res.result.total
          this.tableData = res.result.list;
          this.maxChl = this.tableData[0].xsidAndMcRespList[0].yzwl;
          if (this.pages.currentPage == 1) {
            this.stuAdvanceRankData = this.tableData
          }
        }
      })
    },

    getGroupRankingListAbsence(data) {
      classTempGroupGradeScreenHaveSingle(data).then(res => {
        if (res.result) {
          this.pages.total = res.result.total
          this.tableData = res.result.list;
          this.maxChl = this.tableData[0].xsidAndMcRespList[0].yzwl;
          if (this.pages.currentPage == 1) {
            this.stuAdvanceRankData = this.tableData
          }
        }
      })
    },
    //
    setTimer() {
      this.timer = setInterval(() => {
        this.handelSearch()
      }, 10000)
    },
    // 排名计算
    indexMethod(index) {
      return (this.pages.currentPage - 1) * this.pages.pageSize + index + 1;
    },
    handleCurrentChange(val) {
      this.pages.currentPage = val;


      if (this.keepAbsentStudents) {
        this.getGroupRankingList()
      } else {
        const data = this.search_data;
        data.currentPage = this.pages.currentPage;
        data.pageSize = this.pages.pageSize;
        data.qryDate = this.time_select;
        data.bjrs = 4;
        this.getGroupRankingListAbsence(data)
      }


    },
    handleSizeChange(val) {
      this.pages.pageSize = val;
      this.handelSearch()
    },
    handelSearch() {
      this.pages.currentPage = 1;
      if (this.keepAbsentStudents) {
        this.getGroupRankingList()
      } else {
        const data = this.search_data;
        data.currentPage = this.pages.currentPage;
        data.pageSize = this.pages.pageSize;
        data.qryDate = this.time_select;
        data.bjrs = 4;
        this.getGroupRankingListAbsence(data)
      }
    },
  }
}
</script>
<style lang="scss" scope>


.tea-pagination {
  margin-top: 15px;
}

.group-pk-box {
  width: 100%;
  height: 100%;
  overflow-y: auto; /* 使容器能够滚动 */
  .pk-top {
    display: flex;
    justify-content: space-between;

    .pk-top-right {
      display: flex;
      align-items: center;
    }

    .small {
      font-size: 12px;
      margin-right: 20px;
      margin-left: 20px;
      color: red;
    }

    .title {
      // margin: 10px auto;
      span {
        background: #309bff;
        padding: 5px 20px;
        margin-left: 20px;
        color: #fff;
        border-radius: 18px;
      }
    }
  }

  .main-box {
    width: 100%;
    height: calc(100% - 50px);
  }

  .topChart {
    padding: 0 20px;
    overflow: hidden;

    ul {
      overflow: hidden;
      width: 100%;
      min-width: 1200px;

      li {
        float: left;
        width: 33.33%;
        list-style: none;

        .list {
          background: url(../../../assets/images/teacher/redBackground.png);
          width: 377px;
          height: 203px;

          h5 {
            height: 100px;
            line-height: 76px;
            padding-top: 24px;
            text-indent: 20px;
            font-size: 36px;
            margin: 0;
            color: #fff;
          }

          div {
            width: 50%;
            height: 100px;
            float: left;
            padding-left: 30px;

            p {
              font-size: 14px;
              margin: 0px;
              line-height: 40px;
              color: #fff;

              &:nth-child(2) {
                line-height: 40px;
                font-size: 28px;
              }
            }
          }
        }

        &:nth-child(2) {
          .list {
            background: url(../../../assets/images/teacher/blueBackground.png);
          }
        }

        &:nth-child(3) {
          .list {
            background: url(../../../assets/images/teacher/greenBackground.png);
          }
        }
      }
    }
  }

  .bottomChart {
    height: calc(100% - 440px);
    margin-top: 10px;
    padding: 10px;
  }

  padding-top: 20px;

  ::v-deep  .el-table {
    margin: 20px auto 0;

    .el-table__header {
      .has-gutter {
        th {
          background-color: #eee;
        }
      }
    }

    .el-table__body tr.el-table__row--striped td {
      background: #e1f4ff;
    }
  }


  .group-list {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    padding: 10px;
  }

  .group-item {
    width: 400px;
    min-height: 500px;
    padding: 9px 2px 9px 25px;
    margin: auto;
    box-sizing: border-box;
    background: #f5f5f5;
    border-radius: 10px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }

  .group-name {
    color: #3a63e6;
    font-size: 28px;
    font-weight: 600;
  }

  .group-progress {
    padding: 10px 0 3px 0;
    font-size: 20px;
    color: #3a63e6;
    font-weight: 600;

  }

  .group-student {
    width: 100%;
  }

  .group-student-item {
    display: flex;
    align-items: center;
    margin: 2px 0;

    span {
      width: 118px;
      text-align: left;
    }

    .group-student-speed {
      width: 190px;
      margin-left: 25px;

      .el-progress-bar {
        padding-right: 0 !important;
      }
    }

    .img-gif {
      width: 55px;
      height: 55px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-left: 25px;
    }

    .group-item:first-child {
      border-right: #66b1ff dotted 2px;
    }
  }
}

.empty {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
